/* eslint-disable prettier/prettier */
import MyTeamService from "../../services/teamServices";
import { teamConstants } from "../constants/teamConstants";

export const myTeamActions = (headers) => (dispatch) => {
    MyTeamService.myTeam(headers)
        .then((data) => {
            dispatch({
                type: teamConstants.FETCHING_MYTEAM_API_SUCCESS,
                payload: data.data
            })
        }).catch(err => {
            dispatch({
                type: teamConstants.FETCHING_MYTEAM_API_FAILED,
                payload: err
            })
        })
}
export const teamRefferalActions = (headers) => (dispatch) => {
    MyTeamService.refferal(headers)
        .then((data) => {
            dispatch({
                type: teamConstants.FETCHING_REFFERAL_API_SUCCESS,
                payload: data.data
            })
        }).catch(err => {
            dispatch({
                type: teamConstants.FETCHING_REFFERAL_API_FAILED,
                payload: err
            })
        })
}